import { render } from "./BuyedItem.vue?vue&type=template&id=3d8b431e"
import script from "./BuyedItem.vue?vue&type=script&lang=js"
export * from "./BuyedItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__